// extracted by mini-css-extract-plugin
export default {"container":"container-D7i7Neb1","hidden":"hidden-KIxlNzdk","avatarWrapper":"avatarWrapper-HSuTqmwd","messageContainer":"messageContainer-YkGmcXyR"};